import { Flex } from 'components/Flex';
import {
  NavigationButton,
  NavigationButtonsWrapper,
} from 'modals/ShiftModal/src/views/DetailView/DetailView.styled';
import {
  DetailViewActiveTabType,
  DetailViewComponentMap,
  IDetailViewComponentProps,
} from 'modals/ShiftModal/src/views/DetailView/DetailView.types';
import { FC, useState } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { css } from 'styled-components';

import { CanAssignValidationProvider } from 'modals/ShiftModal/src/views/DetailView/ConfirmAvailabilityModal/CanAssignValidation.validation.context';
import { usePathname } from 'hooks/usePathname';
import { getDefaultDetailViewTab, isTimesheetsTabAvailable } from '../DetailView.constants';
import { AuditTrailDetailTabViewFooter } from 'modals/ShiftModal/src/views/DetailView/AuditTrailDetailView/AuditTrailDetailTabViewFooter';

const tabs: [string, DetailViewActiveTabType][] = [
  ['General', 'GeneralTab'],
  ['Activity', 'AuditTrailActivityTab'],
  ['Timesheets', 'TimesheetsTab'],
];

export const AuditTrailDetailTabView: FC<IDetailViewComponentProps> = ({ data }) => {
  const order = data?.order;
  const { t, i18n } = useTranslation();
  const pathname = usePathname();
  const [activeTab, setActiveTab] = useState<DetailViewActiveTabType>(() =>
    getDefaultDetailViewTab(pathname, order),
  );
  const ActiveTabComponent = DetailViewComponentMap[activeTab];

  const timeZone = order!.timeZone?.toString();

  return (
    <CanAssignValidationProvider>
      <Flex
        flexDirection="column"
        height="fit-content"
        minHeight="fit-content"
        css={css`
          position: sticky;
          background-color: white;
          z-index: 1;
          top: 0;
        `}
      >
        <NavigationButtonsWrapper>
          {tabs
            .filter(([, key]) => {
              if (key === 'TimesheetsTab') {
                return isTimesheetsTabAvailable(order!);
              }
              return true;
            })
            .map(([label, _enum]) => {
              const translatedLabel = label.toUpperCase();
              return (
                <NavigationButton
                  key={label}
                  isDisabled={
                    !!(
                      label === 'Activity' &&
                      ((!!order!.isAway && !order!.sentToAgencies) || !!order!.isExternal)
                    )
                  }
                  onClick={() => activeTab !== _enum && setActiveTab(_enum)}
                  isActive={activeTab === _enum}
                >
                  {i18n.exists(`shift_modal:${translatedLabel}`)
                    ? t(`shift_modal:${translatedLabel}`)
                    : label}
                </NavigationButton>
              );
            })}
        </NavigationButtonsWrapper>
      </Flex>

      <ActiveTabComponent timeZone={timeZone} data={data} />

      {activeTab !== 'TimesheetsTab' && <AuditTrailDetailTabViewFooter />}
    </CanAssignValidationProvider>
  );
};
